
export default {
    user:null,
    administrador:0,
    usuario_logado:0,
    permissao:[]
  }
  